import { getUserConfiguration } from 'owa-session-store';
export function getLeftNavInitState(): boolean | undefined {
    const userConfiguration = getUserConfiguration();
    return userConfiguration.ViewStateConfiguration?.CalendarSidePanelIsExpanded;
}
